import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCashbookStatus } from "../../../helpers/cashbookStatus";
import { myCashInHand, SupervisorCash, supervisorsCash } from "../cashbook/cashFigures";
import { rupees } from "../rates/rateModel";
import { useKT } from "../i18n/kt";
import { kp } from "../karkhanaPaths";

/**
 * The cash with supervisors, on the Pay page. The owner sees each supervisor's cash and hands more
 * over from here; a supervisor sees what is in their own hand. With the Cash book add-on the figures
 * are the cash book's (same as the नकद tab) and "Hand over" opens that supervisor's cash book day.
 */
const CashCard = ({ supervisor }: { supervisor: boolean }) => {
  const { t } = useKT();
  const cashbook = useCashbookStatus();
  const on = cashbook.loaded && cashbook.enabled;
  const [mine, setMine] = useState<string | number | null>(null);
  const [sups, setSups] = useState<SupervisorCash[] | null>(null);

  useEffect(() => {
    if (!cashbook.loaded) return;
    let live = true;
    if (supervisor) myCashInHand(on).then((v) => live && setMine(v));
    else supervisorsCash(on).then((v) => live && setSups(v));
    return () => {
      live = false;
    };
  }, [supervisor, on, cashbook.loaded]);

  if (supervisor) {
    if (mine === null) return null;
    return (
      <div className="kpy-card">
        <div className="kpy-card__main">
          <strong>{t("Cash book")}</strong>
          <span>
            {t("In your hand")}: <b>{rupees(mine, 0)}</b>
          </span>
        </div>
        <Link to={kp.cashBook()} className="kd-btn kd-btn--line kd-btn--sm">
          {t("Open")}
        </Link>
      </div>
    );
  }
  if (!sups) return null;
  if (!sups.length) {
    return (
      <div className="kpy-card">
        <div className="kpy-card__main">
          <strong>{t("Cash book")}</strong>
          <span>{t("Add a supervisor to hand them cash for paying people.")}</span>
        </div>
        <Link to={kp.supervisors()} className="kd-btn kd-btn--line kd-btn--sm">
          {t("Supervisors")}
        </Link>
      </div>
    );
  }
  return (
    <div className="kpy-card is-stack">
      <strong>{t("Cash book")}</strong>
      {sups.map((s) => (
        <div key={s.id} className="kpy-card__row">
          <span>
            {t("With {{name}} (supervisor)", { name: s.name })}: <b>{rupees(s.cashInHand ?? 0, 0)}</b>
          </span>
          <Link to={on ? kp.cashHolder(s.id, { act: "handover" }) : kp.cashBook({ supervisor: s.id })} className="kd-btn kd-btn--line kd-btn--sm">
            {t("Hand over")}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default CashCard;
